import { Helpers } from "./helpers";

export namespace MathFunctions {
    /* Returns a window of the given items array */
    export function getRangeCenteredAt<T>(centerIdx: number, size: number, items: T[]): T[] {
        var flanking = Math.floor(size / 2);

        if (centerIdx - flanking <= 0) {
            return items.slice(0, size);
        }

        if (centerIdx + flanking > items.length - 1) {
            const sliceIdx = Math.max(0, items.length - size);
            return items.slice(sliceIdx);
        }

        return items.slice(centerIdx - flanking, centerIdx + flanking);
    }

    export function range(start = 0, end = 0, step = 1) {
        if (start === end || step === 0) {
            return [];
        }

        const diff = Math.abs(end - start);
        const length = Math.ceil(diff / step);

        return start > end
            ? Helpers.FromArray({ length }, (value, key) => start - key * step)
            : Helpers.FromArray({ length }, (value, key) => start + key * step);
    }
}
